import { Avatar, Box, Button, ButtonGroup, Grid, List, ListItem, ListItemAvatar, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { api } from 'src/api/endpoints';
import { get20daysUsersScreenStats, getUserScreensRanking } from 'src/redux/actions/ScreenStats';
import ScreenDataUsageStatsChart from 'src/views/screendetails/ScreenDataUsageStatsChart';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export default function UserScreensInternetRanking() {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [ daysPeriod, setDaysPeriod ] = useState('30')
    const [ currentScreen, setCurrentScreen ] = useState({data: null, mac: ''})

    const { twentyDaysUserStats, userRanking } = useSelector((state) => state.ScreenStats);

    const retrieveScreenData = async (mac) => {
        const date = new Date()
        date.setDate(date.getDate() - Number(daysPeriod))
        try{
            const {data} = await api.post('/screenStats/getScreenDataUsageStaticsPeriod', {
                screenMac: mac,
                dateTo: new Date().toISOString().split('T')[0],
                dateFrom: date.toISOString().split('T')[0],
            })
            setCurrentScreen({data: data.periodScreenStats, mac: mac})
        } catch (error) {

        }
    }
    
    function formatBytes(bytes, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const dm = decimals < 0 ? 0 : decimals
    
        return `${parseFloat((bytes / 1073741824).toFixed(4))} GB`
    }

    useEffect(() => {
        dispatch(getUserScreensRanking(Number(daysPeriod)))
        setCurrentScreen({data: null, mac: ''})
        if(daysPeriod){
            dispatch(get20daysUsersScreenStats(daysPeriod))
        }
    }, [daysPeriod])

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            <ToggleButtonGroup
                color="primary"
                value={daysPeriod}
                exclusive
                onChange={(e, v) => setDaysPeriod(v)}
                aria-label="Days period"
            >
                <ToggleButton value="30">{t("views.dashboard.month")}</ToggleButton>
                <ToggleButton value="60">{t("views.dashboard.monthsTwo")}</ToggleButton>
                <ToggleButton value="90">{t("views.dashboard.monthsThree")}</ToggleButton>
                <ToggleButton value="180">{t("views.dashboard.halfAYear")}</ToggleButton>
            </ToggleButtonGroup>
            <Grid container spacing={3} mt={3}>
                <Grid item xs={12} md={12} lg={12} xl={6}>
                    <TableContainer sx={{
                        width: '100%'
                    }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("views.dashboard.screen")}</TableCell>
                                    <TableCell>{t("views.dashboard.sent")}</TableCell>
                                    <TableCell>{t("views.dashboard.downloaded")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userRanking.length > 0 ? userRanking.map(screen => {
                                    return (
                                        <TableRow>
                                            <TableCell>
                                                <Button onClick={() => retrieveScreenData(screen._id)} color={screen._id == currentScreen.mac ? 'success' : 'primary'}>{screen.screenData.deviceName}</Button>
                                            </TableCell>
                                            <TableCell>{formatBytes(screen.totalScreenSent)}</TableCell>
                                            <TableCell>{formatBytes(screen.totalScreenReceived)}</TableCell>
                                        </TableRow>
                                    )
                                }) : (
                                    <TableRow>
                                        <TableCell colSpan={3}>{t("views.dashboard.noScreensToShow")}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={6}>
                    {currentScreen.data ? (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <List>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <CloudDownloadIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={formatBytes(currentScreen.data?.totalPeriodReceivedBytes)} secondary={t("views.screenDetail.receivedLabel")} />
                                    </ListItem>
                                </List>
                                <List>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                <CloudUploadIcon/>
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={formatBytes(currentScreen.data?.totalPeriodSentBytes)} secondary={t("views.screenDetail.sentLabel")} />
                                    </ListItem>
                                </List>
                            </Box>
                            <ScreenDataUsageStatsChart formatBytes={formatBytes} screenStats={currentScreen?.data?.screenStats} />
                        </Box>
                    ) : (
                        <Box>
                            <Typography variant="h5" textAlign="center">{t("views.dashboard.totalUsage")}</Typography>
                            {/* <Typography variant="subtitle2" textAlign="center">{t("views.dashboard.fromFiftyDays")}</Typography> */}
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <ScreenDataUsageStatsChart formatBytes={formatBytes} screenStats={twentyDaysUserStats.map(ds => {
                                    return {
                                        ...ds,
                                        date: ds._id,
                                        totalSentBytes: ds.totalSent,
                                        totalReceivedBytes: ds.totalReceived
                                    }
                                })} />
                            </Box>
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}
